import React, { useEffect, useState } from "react";
import { main_server } from "../../constants";
import { Spotlight } from "../../ui/spotlight";
import { Sparkels } from "../";
import styles from "./index.module.css";

const ResetPassword = (props) => {
  const [pass, setPass] = useState("");
  const [confirm, setConfirm] = useState("");
  const [token, setToken] = useState("");
  const [passValid, setPassValid] = useState(0);
  const [confirmValid, setConfirmValid] = useState(0);

  useEffect(() => {
    props.setSelected(2);
    props.setShow(true);
    const query = window.location.search;
    if (query.includes('?token=')) {
      setToken(query.split('?token=')[1]);
    }
    document.body.classList.add('darkMode');
    document.body.classList.add('dark');
  }, []);

  async function resetPassword() {
    if (passValid !== 1) {
      props.setAlertType(false);
      props.setAlertText("Password should be at least 8 characters, include uppercase, lowercase, and a special character.");
      props.setShowAlert(true);
      setTimeout(() => props.setShowAlert(false), 3000);
      return;
    }
    if (confirmValid !== 1) {
      props.setAlertType(false);
      props.setAlertText("Passwords do not match.");
      props.setShowAlert(true);
      setTimeout(() => props.setShowAlert(false), 3000);
      return;
    }
    if (token.length === 0) {
      props.setAlertType(false);
      props.setAlertText("Invalid reset token.");
      props.setShowAlert(true);
      setTimeout(() => props.setShowAlert(false), 3000);
      return;
    }

    const response = await fetch(
      main_server + "resetPass",
      {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        body: JSON.stringify({
          token,
          pass
        }),
      },
    );
    
    if (response.status === 200) {
      props.setAlertType(true);
      props.setAlertText("Password reset successfully! You can now login with your new password.");
      props.setShowAlert(true);
      setTimeout(() => {
        props.setShowAlert(false);
        window.location.href = "/login";
      }, 3000);
    } else if (response.status === 400) {
      const content = await response.text();
      props.setAlertType(false);
      props.setAlertText(content);
      props.setShowAlert(true);
      setTimeout(() => props.setShowAlert(false), 3000);
    } else {
      props.setAlertType(false);
      props.setAlertText("Unexpected error, please try again later.");
      props.setShowAlert(true);
      setTimeout(() => props.setShowAlert(false), 3000);
    }
  }

  return (
    <section className={`${styles.container} absolute top-0 pt-[75px] w-full h-full left-0`}>
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-sm mx-auto">
        <Spotlight
              className="-top-40 left-0 md:left-60"
              fill="white"
              active={true}
            />
          <div className={styles.cardWrapper}>
            
            <div className={`${styles.card} text-center`}>
              <h1 className={styles.title}>
                Reset Password
              </h1>
              <Sparkels />
              <p className={styles.subtitle}>
                Enter your new password below to reset your account password.
              </p>

              <form className="mt-8">
                <div className="space-y-4">
                  <div>
                    <label htmlFor="password" className={styles.label}>
                      New Password
                    </label>
                    <div className="mt-2">
                      <input
                        type="password"
                        name="password"
                        id="password"
                        placeholder="Min. 8 characters, uppercase, lowercase and a sign"
                        value={pass}
                        onChange={(e) => {
                          setPass(e.target.value);
                          if (e.target.value.length > 0) {
                            const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/;
                            if (re.test(e.target.value)) {
                              setPassValid(1);
                            } else {
                              setPassValid(2);
                            }
                            if (confirm.length > 0) {
                              if (e.target.value === confirm) {
                                setConfirmValid(1);
                              } else {
                                setConfirmValid(2);
                              }
                            }
                          } else {
                            setPassValid(0);
                          }
                        }}
                        className={`${styles.input} ${passValid === 1 ? "border-green-300" : passValid === 2 ? "border-red-300" : ""}`}
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="confirm-password" className={styles.label}>
                      Confirm Password
                    </label>
                    <div className="mt-2">
                      <input
                        type="password"
                        name="confirm-password"
                        id="confirm-password"
                        placeholder="Confirm your new password"
                        value={confirm}
                        onChange={(e) => {
                          setConfirm(e.target.value);
                          if (e.target.value.length > 0) {
                            if (e.target.value === pass) {
                              setConfirmValid(1);
                            } else {
                              setConfirmValid(2);
                            }
                          } else {
                            setConfirmValid(0);
                          }
                        }}
                        className={`${styles.input} ${confirmValid === 1 ? "border-green-300" : confirmValid === 2 ? "border-red-300" : ""}`}
                      />
                    </div>
                  </div>

                  <div>
                    <div
                      onClick={() => resetPassword()}
                      className={styles.button}
                      style={{ cursor: 'pointer' }}
                    >
                      Reset Password
                    </div>
                  </div>
                </div>
              </form>

              <div className="mt-6 text-center">
                <p className={styles.checkboxLabel}>
                  Remember your password?{" "}
                  <a
                    href="/login"
                    title=""
                    className={styles.link}
                    style={{ fontWeight: 'bold', cursor: 'pointer' }}
                  >
                    Back to Login
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
